import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import BusinessLogo from "../../../assets/images/logo.png";
import { useAppSelector } from "../../../hooks/redux.hook";
import { authSelector } from "../../../app/features/auth/auth.slice";
import { AppRoutes } from "../../../utils/mapping/appRoutes.mapping";
import { commonSelector } from "../../../app/features/common/common.slice";
import ModalAlert from "../../../components/global/ModalAlert";
import ModalConfirm from "../../../components/global/ModalConfirm";

const PublicLayout = () => {
  const navigate = useNavigate();
  const { modalAlert, modalConfirm } = useAppSelector(commonSelector);
  const { token } = useAppSelector(authSelector);
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    if (token) {
      navigate(AppRoutes.home, { replace: true });
    } else {
      setValidating(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (validating) {
    return (
      <div className="h-screen w-screen">
        <div className="layer-global-loader-public next-global-loader items-center">
          <img alt="logo loader" src={BusinessLogo} className="my-auto mx-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen">
      <video
        style={{
          width: "100vw",
          height: "100vh",
          objectFit: "cover",
          position: "fixed",
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
          zIndex: "-1",
          filter: "brightness(50%)",
        }}
        width="100%"
        height="auto"
        autoPlay={true}
        muted={true}
        loop={true}
        preload="https://prodac.pe/wp-content/uploads/2023/08/4-grating.mp44"
      >
        <source src="https://prodac.pe/wp-content/uploads/2023/08/4-grating.mp4" />
      </video>
      <Outlet />
      {modalAlert.isOpen && <ModalAlert />}
      {modalConfirm.isOpen && <ModalConfirm />}
    </div>
  );
};

export default PublicLayout;
